<template>
  <div v-if="showNews" class="wrap">
    <div class="news">
      <div class="newsTitle">新闻中心</div>
      <div class="newsEn">NEWS CENTER</div>
      <a-carousel arrows>
        <template #prevArrow>
          <div
            class="custom-slick-arrow custom-slick-arrow-left"
            style="left: -55px; top: 282px; z-index: 1"
          >
            <img
              class="arrow arrow-left"
              src="https://p2.ssl.qhimg.com/t110b9a93019676e0da7bff4584.png"
              alt=""
            />
          </div>
        </template>
        <template #nextArrow>
          <div style="top: 282px; left: 99%" class="custom-slick-arrow custom-slick-arrow-right">
            <img
              class="arrow arrow-right"
              src="https://p1.ssl.qhimg.com/t110b9a93017944829ce9c5b92b.png"
              alt=""
            />
          </div>
        </template>
        <div v-for="(item, index) in arr" :key="index" class="newsBox">
          <div class="newsBoxInfo">
            <div
              @click="jumpLink(child.url)"
              v-for="(child, index) in item"
              :key="index"
              class="newsBoxInfoItem"
            >
              <img :src="child.cover" alt="" class="zoomImg newsBoxInfoItemImg" />
              <div class="newsBoxInfoItemName">
                {{ child.title }}
              </div>
              <a-tooltip :color="color">
                <template #title>
                  <div class="tooltip-content">{{ child.desc }}</div>
                </template>
                <div class="newsBoxInfoItemDesc">{{ child.desc }}</div>
              </a-tooltip>
              <div
                class="newsBoxInfoItemDetail"
                @mouseover="handleMouseOver(index)"
                @mouseleave="handleMouseLeave"
              >
                <span class="newsBoxInfoItemDetailText">查看详情</span>
                <img
                  :src="
                    hoveredIndex === index
                      ? 'https://s3.ssl.qhres2.com/static/ffa55d01d284e4cb.svg'
                      : 'https://p4.ssl.qhimg.com/t110b9a9301e650fa891a7c3676.png'
                  "
                  alt=""
                  class="newsBoxInfoItemDetailIcon"
                />
              </div>
            </div>
          </div>
        </div>
      </a-carousel>
    </div>
    <img src="https://p5.ssl.qhimg.com/t110b9a9301e8690720581802bd.png" alt="" class="newsImg" />
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getNews } from '@/api/2024/index.js'

const arr = ref([])
const hoveredIndex = ref(-1)
const showNews = ref(true)

onBeforeMount(async () => {
  await fetch()
})

const color = ref('#000000')

const jumpLink = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}

const fetch = () => {
  getNews('297785').then((res) => {
    let news = res.data.data.list
    arr.value = chunkArray(news, 3)
  }).catch(error => {
    showNews.value = false
  })
}

const chunkArray = (array, chunkSize) => {
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize))
  }
  return result
}

const handleMouseOver = (index) => {
  hoveredIndex.value = index
}

const handleMouseLeave = () => {
  hoveredIndex.value = -1
}
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background-color: #f3f3f3;
  padding: 90px 0 193px;
}

.news {
  width: 90%;
  margin: 0 auto;
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    color: #242933;
  }
  &En {
    margin-top: 16px;
    margin-bottom: 110px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #8a9099;
    display: inline-block;
  }
  &Box {
    &Info {
      display: flex;
      width: 94%;
      margin: 0 auto;
      &Item {
        cursor: pointer;
        margin-right: 32px;
        width: 512px;
        border-radius: 32px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(120px);
        transition: transform 0.3s ease;

        &Img {
          border-radius: 32px 32px 0 0;
          width: 100%;
          display: block;
        }
        &Name {
          margin: 32px 32px 24px;
          font-family: Source Han Sans;
          font-size: 24px;
          font-weight: 500;
          line-height: 32px;
          letter-spacing: 0px;
          font-variation-settings: 'opsz' auto;
          color: #242933;
          text-align: left;
          min-height: 60px;
        }
        &Desc {
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 28px;
          color: #525966;
          margin: 0 32px 38px;
          text-align-last: left;
          text-align: justify;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }
        &Detail {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 24px 0;
          &Text {
            font-family: PingFang SC;
            font-size: 18px;
            line-height: 26px;
            color: #525966;
            margin-left: 8px;
          }
          &Icon {
            width: 20px;
            height: 20px;
          }
        }
        &Detail::v-deep(:hover) {
          color: #497ced !important;
        }
      }
      &Item:hover {
        transform: scale(1.1);
      }
      &Item:last-child {
        margin-right: 0;
      }
    }
  }
  &Img {
    width: 370px;
    position: absolute;
    bottom: 108px;
    left: 0;
  }
}
.ant-carousel {
  z-index: 10;
}
:deep(.slick-slide) {
  text-align: center;
  padding: 0 0 120px;
}

:deep(.slick-arrow) {
  width: 64px;
}

.arrow {
  width: 64px;
}

.ant-carousel :deep(.slick-dots li button) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #dfe1e6;
}
:deep(.slick-dots li.slick-active button) {
  background-color: #525966 !important;
}
</style>
